import React, { useState, useEffect } from "react";
import Anuncio from "./anuncio";
import Contact from "../Contact/contact";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import LinearProgress from "@mui/material/LinearProgress";
import Campaign from "@mui/icons-material/Campaign";
import { obtenerAnuncios } from "../Services/anunciosServices";
import { Container } from "@mui/material";

const Anuncios = () => {
  const [anuncios, setAnuncio] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    cargarAnuncios();
    /*fetch("http://localhost:5000/api/Pelicula")
      .then((response) => response.json())
      .then((data) => setPeliculas(data));*/
  }, []);

  const cargarAnuncios = async () => {
    const { data: anuncios } = await obtenerAnuncios();
    setAnuncio(anuncios);
    setLoading(false);
    //console.log(anuncios);
  };

  return (
    <>
      {loading && <LinearProgress />}
      <Container
        maxWidth="sm xs lg"
        sx={{ backgroundColor: "white" }}
        disableGutters
      >
        <div className="main-bg13">
          <div className="main-title5">
            <h1>
              ANUNCIOS
              <Campaign
                sx={{ fontSize: 70, color: "#FFF", verticalAlign: "middle" }}
              />
            </h1>
          </div>
        </div>
      </Container>
      <Container sx={{ p: 2, backgroundColor: "white" }}>
        <section>
          <h3 style={{ textAlign: "center" }}>Anuncios</h3>
          <List
            sx={{
              margin: "auto",
              width: "80%",
              maxWidth: "80%",
              bgcolor: "background.paper",
            }}
          >
            {anuncios.map((a) => (
              <Anuncio anuncio={a} key={a.idAnuncio}></Anuncio>
            ))}
          </List>
        </section>
      </Container>
      <Contact />
    </>
  );
};

export default Anuncios;
